import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useGoldenRulesPageVM = () => {
    const [hasSeenAllPages, setHasSeenAllPages] = useState<boolean>(false);
    const navigate = useNavigate();

    const navigateBackToModule = () => {
        navigate('/sante-securite');
    };

    return { hasSeenAllPages, setHasSeenAllPages, navigateBackToModule };
};
